import React, { useContext } from 'react'
import { DataContext } from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import DetailChart from './chart/DetailChart'

const ExpandableDetailChart = ({ visible }) => {
    const { chartExpanded } = useContext(DataContext)
    return (
        <div
            className={`${
                visible && chartExpanded ? 'fullscreen-overlay' : 'is-collapsed'
            }`}
        >
            <Panel panelClassConfig={panelClassConfig()}>
                <DetailChart />
            </Panel>
        </div>
    )
}
export default ExpandableDetailChart
